module.exports = __webpack_public_path__ + "img/preventivi-white.e1b2f61c.svg";